export const parseVerticalPoints = (verticalGeometry, tesselation) => {
    let points = [];
    verticalGeometry.forEach(el => {
        if(el.type === "line")
        {
            points.push(
                {
                    stationing: el.startStationing,
                    elevation: el.startElevation,
                    slope: (el.endElevation - el.startElevation)/(el.endStationing - el.startStationing)
                },
                {
                    stationing: el.endStationing,
                    elevation: el.endElevation,
                    slope: (el.endElevation - el.startElevation)/(el.endStationing - el.startStationing)
                },
            );
        }
        else if(el.type === "arc")
        {
            let center = [];

            if(el.radius > 0)
            {
                center[0] = (0.5 * el.startStationing + 0.5 * el.endStationing) + (Math.sqrt(el.radius**2 - 0.25 * (el.endStationing - el.startStationing)**2 - 0.25 * (el.endElevation - el.startElevation)**2)*(el.endElevation - el.startElevation))/(Math.sqrt((el.endStationing - el.startStationing)**2 + (el.endElevation - el.startElevation)**2));
                center[1] = (0.5 * el.startElevation + 0.5 * el.endElevation) - (Math.sqrt(el.radius**2 - 0.25 * (el.endStationing - el.startStationing)**2 - 0.25 * (el.endElevation - el.startElevation)**2)*(el.endStationing - el.startStationing))/(Math.sqrt((el.endStationing - el.startStationing)**2 + (el.endElevation - el.startElevation)**2));
            }
            else if(el.radius < 0)
            {
                center[0] = (0.5 * el.startStationing + 0.5 * el.endStationing) - (Math.sqrt(el.radius**2 - 0.25 * (el.endStationing - el.startStationing)**2 - 0.25 * (el.endElevation - el.startElevation)**2)*(el.endElevation - el.startElevation))/(Math.sqrt((el.endStationing - el.startStationing)**2 + (el.endElevation - el.startElevation)**2));
                center[1] = (0.5 * el.startElevation + 0.5 * el.endElevation) + (Math.sqrt(el.radius**2 - 0.25 * (el.endStationing - el.startStationing)**2 - 0.25 * (el.endElevation - el.startElevation)**2)*(el.endStationing - el.startStationing))/(Math.sqrt((el.endStationing - el.startStationing)**2 + (el.endElevation - el.startElevation)**2));
            }

            let circleIntervals = 100;
            if(tesselation) circleIntervals = tesselation;

            let theta = Math.atan2(
                (el.startStationing - center[0]) * (el.endElevation - center[1]) - (el.startElevation - center[1]) * (el.endStationing - center[0]),
                (el.startStationing - center[0]) * (el.endStationing - center[0]) + (el.startElevation - center[1]) * (el.endElevation - center[1])
            );

            let directionalVector = [el.startStationing - center[0], el.startElevation - center[1]];

            for(let i = 0; i <= circleIntervals; i++)
            {
                points.push(
                    {
                       stationing: center[0] + directionalVector[0] * Math.cos(theta * i/circleIntervals) - directionalVector[1] * Math.sin(theta * i/circleIntervals),
                       elevation:  center[1] + directionalVector[0] * Math.sin(theta * i/circleIntervals) + directionalVector[1] * Math.cos(theta * i/circleIntervals),
                       slope: ((center[1] + directionalVector[0] * Math.sin((i+1) * theta/circleIntervals) + directionalVector[1] * Math.cos((i+1) * theta/circleIntervals)) - (center[1] + directionalVector[0] * Math.sin(i * theta/circleIntervals) + directionalVector[1] * Math.cos(i * theta/circleIntervals)))/((center[0] + directionalVector[0] * Math.cos((i+1) * theta/circleIntervals) - directionalVector[1] * Math.sin((i+1) * theta/circleIntervals)) - (center[0] + directionalVector[0] * Math.cos(i * theta/circleIntervals) - directionalVector[1] * Math.sin(i * theta/circleIntervals)))
                    }
                )
            }
        }
    });
    
    return points;
}